// extracted by mini-css-extract-plugin
export default {"AppLoadFailureScreen":"AppLoadFailureScreen_AppLoadFailureScreen__3bJXV"};